import { render } from "./RailIconLeft.vue?vue&type=template&id=8668b1e4&scoped=true"
const script = {}

import "./RailIconLeft.vue?vue&type=style&index=0&id=8668b1e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8668b1e4"]])

export default __exports__